<!-- DateRangePicker is the UI control that lets the user select a min–max date range for the K-Diagram calculation. -->

<template>
  <v-row no-gutters>
    <v-col no-gutters :cols="12">
      <div class="d-flex align-center mb-2" style="color: var(--color-text)">
        <v-icon color="var(--color-text)">mdi-calendar</v-icon>
        <span
          class="text-subtitle-1 font-weight-light mr-1"
          style="color: var(--color-text)"
        >
          Date range</span
        >
        <span
          class="text-subtitle-2 font-weight-light mr-1"
          style="color: var(--color-text)"
          >(min - max)</span
        >
      </div>

      <v-dialog
        ref="dateDialog"
        v-model="modal"
        persistent
        width="290px"
        :return-value.sync="dateModel"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            :value="displayDate(dateModel)"
            outlined
            readonly
            persistent-placeholder
            hide-details="auto"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="dateModel"
          :value="[calculationData.minDate, calculationData.maxDate]"
          scrollable
          range
          @change="onChange"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.dateDialog.save(dateModel)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
  </v-row>
</template>

    <script>
import { mapState } from "vuex";
import KDiagramCalculationData from "../../../domain/kdiagram/calculation/data";
import ThemedTextField from "../../../core/ThemedTextField.vue";
export default {
  name: "DateRangePicker",
  components: {
    ThemedTextField,
  },
  data: function () {
    return {
      modal: false,
      dateModel: [],
    };
  },
  computed: {
    ...mapState("kDiagram", ["calculationData"]),
    defaultDateRange() {
      const defaultData = KDiagramCalculationData.defaultData();
      return `${defaultData.minDate} - ${defaultData.maxDate}`;
    },
  },
  created() {
    this.dateModel = [
      this.calculationData.minDate,
      this.calculationData.maxDate,
    ];
  },
  methods: {
    onChange(date) {
      this.$store.commit("kDiagram/SET_DATE_RANGE", this._orderDates(date));
    },
    displayDate(dateRange) {
      if (dateRange[0] == undefined || dateRange[1] == undefined) {
        return this.defaultDateRange;
      }
      return this._orderDates(dateRange).join(" - ");
    },
    _orderDates(dateRange) {
      // Create a shallow copy of the dateRange to avoid infinite rerendering of the component
      const sortedDates = [...dateRange].sort(
        (a, b) => new Date(a) - new Date(b)
      );
      return sortedDates;
    },
  },
};
</script>
